import EmpresaService from '@/service/EmpresaService'

export default {
  namespaced: true,
  state: {
    isOnline: null,
    configUnidade: null,
    msgErro: null,
    codUnidade: null,
  },
  getters: {
    isOnline(state) {
      return state.isOnline
    },
    configUnidade(state) {
      return state.configUnidade
    },
    msgErro(state) {
      return state.msgErro
    },
    codUnidade(state) {
      return state.codUnidade
    },
  },
  mutations: {
    UPDATE_ONLINE(state, isOnline) {
      state.isOnline = isOnline
    },
    UPDATE_CONFIG_UNIDADE(state, configUnidade) {
      state.configUnidade = configUnidade
    },
    UPDATE_MSG_ERRO(state, msgErro) {
      state.msgErro = msgErro
    },
    UPDATE_COD_UNIDADE(state, codUnidade) {
      state.codUnidade = codUnidade
    },
  },
  actions: {
    async verificaOnlineStatus({ commit }, empresaId) {
      const isOnline = await EmpresaService.verificaOnline(empresaId)
      commit('UPDATE_ONLINE', isOnline)
      return isOnline
    },
    async switchOnline({ commit }, empresaId) {
      const isOnline = await EmpresaService.switchOnline(empresaId)
      commit('UPDATE_ONLINE', isOnline)
      return isOnline
    },
    async salvarConfiguracoesUnidade({ commit, state }, empresaId) {
      const configUnidade = await EmpresaService.salvarConfiguracoesUnidade(empresaId, state.configUnidade)
      commit('UPDATE_CONFIG_UNIDADE', configUnidade)
    },
    async configuracoesUnidade({ commit }, empresaId) {
      const configUnidade = await EmpresaService.configuracoesUnidade(empresaId)
      commit('UPDATE_CONFIG_UNIDADE', configUnidade)
    },
    async salvarEnvioDecConteudo({ commit }, empresaId) {
      const configUnidade = await EmpresaService.salvarEnvioDecConteudo(empresaId)
      commit('UPDATE_CONFIG_UNIDADE', configUnidade)
    },
    async salvarValidaCepCorreio({ commit }, empresaId) {
      const configUnidade = await EmpresaService.salvarValidaCepCorreio(empresaId)
      commit('UPDATE_CONFIG_UNIDADE', configUnidade)
    },
    async msgErroFtp({ commit }, empresaId) {
      const msg = await EmpresaService.getMsgErroFtp(empresaId)
      commit('UPDATE_MSG_ERRO', msg)
    },
    async salvarLinksClientes({ commit }, dados) {
      const configUnidade = await EmpresaService.salvarLinksClientes(dados)
      commit('UPDATE_CONFIG_UNIDADE', configUnidade)
    },
    async getCodUnidade({ commit }, empresaId) {
      const codUnidade = await EmpresaService.getCodUnidade(empresaId)
      commit('UPDATE_COD_UNIDADE', codUnidade)
    },
  },
}
